var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.6 0V1.6H10.4V0H12V1.6H15.2C15.6418 1.6 16 1.95818 16 2.4V15.2C16 15.6418 15.6418 16 15.2 16H0.8C0.358176 16 0 15.6418 0 15.2V2.4C0 1.95818 0.358176 1.6 0.8 1.6H4V0H5.6ZM14.4 7.2H1.6V14.4H14.4V7.2ZM10.4284 8.1088L11.5598 9.24024L7.6 13.2L4.77158 10.3716L5.90294 9.24024L7.6 10.9373L10.4284 8.1088ZM4 3.2H1.6V5.6H14.4V3.2H12V4H10.4V3.2H5.6V4H4V3.2Z",
    fill: "#8A8989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionLogo);
export default __webpack_public_path__ + "static/media/subscription_logo.33c5077483b15ee47b2f4cce4facc2a4.svg";
export { ForwardRef as ReactComponent };